import { List as TaxAuthoritiesList } from '../parameters/tax_authority';
import { List as CountriesList } from '../parameters/p_country';
import { List as AppStatusList } from '../parameters/app_status';
import { List as AppDurationList } from '../parameters/duration';
import { List as TagsList } from '../parameters/tags';
import { List as CustomFieldsList } from '../custom-fields';
import type { HubModuleDefinition } from './hubConfig';

/** Permission keys for sidebar Parameters menu visibility. */
export const PARAMETER_PERMISSION_MODULE_KEYS = [
  'app_status',
  'app_duration',
  'p_country',
  'tax_authority',
  'tags',
  'custom_fields',
] as const;

export type ParameterPermissionModuleKey = (typeof PARAMETER_PERMISSION_MODULE_KEYS)[number];

/** Merged Communication + Reference data modules (sidebar → Parameters). */
export const PARAMETER_MODULES: HubModuleDefinition[] = [
  {
    id: 'app_status',
    title: 'Appointment Status',
    description: 'Maintain appointment status options and badge colors.',
    route: '/app_status',
    permissionModuleKey: 'app_status',
    hubPassesEmbedded: true,
    component: AppStatusList,
  },
  {
    id: 'app_duration',
    title: 'Appointment Durations',
    description: 'Presets for the duration dropdown when scheduling appointments.',
    route: '/duration',
    permissionModuleKey: 'app_duration',
    hubPassesEmbedded: true,
    component: AppDurationList,
  },
  {
    id: 'p_country',
    title: 'Countries',
    description: 'Maintain the list of countries.',
    route: '/p_country',
    permissionModuleKey: 'p_country',
    hubPassesEmbedded: true,
    component: CountriesList,
  },
  {
    id: 'tax_authority',
    title: 'Tax Authorities',
    description: 'Maintain tax authority values.',
    route: '/tax_authority',
    permissionModuleKey: 'tax_authority',
    hubPassesEmbedded: true,
    component: TaxAuthoritiesList,
  },
  {
    id: 'tags',
    title: 'Tags',
    description: 'Maintain shared tagging options.',
    route: '/tags',
    permissionModuleKey: 'tags',
    hubPassesEmbedded: true,
    component: TagsList,
  },
  {
    id: 'custom_fields',
    title: 'Custom Fields',
    description: 'Define extra fields for clients, appointments, emails, and other entities.',
    route: '/custom-fields',
    permissionModuleKey: 'custom_fields',
    hubPassesEmbedded: true,
    component: CustomFieldsList,
  },
];
